import React from 'react';
import PropTypes from 'prop-types';
import {Button} from 'react-bootstrap';

export default function AuthenticatePinterest(props) {
    const {authUrl, handleCancelAuthenticate} = props;

    return (
        <div id="authenticate-pinterest" className="authenticate-platform-view">
            <div className="authenticate-copy">
                Please connect your Pinterest account to Social Native in order to select/create a
                board for your Pinterest Ad
            </div>

            <div className="authenticate-ctas ad-mode-buttons">
                <Button bsStyle="pinterest" href={authUrl}>
                    Connect To Pinterest
                </Button>
                <Button onClick={handleCancelAuthenticate}>Cancel</Button>
            </div>
        </div>
    );
}

AuthenticatePinterest.propTypes = {
    authUrl: PropTypes.string.isRequired,
    handleCancelAuthenticate: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./campaign_analytics/v2/campaign_analytics_page/posts/ad_mode/ad_mode_info/components/views/authenticate/pinterest.js